import { createRouter, createWebHistory } from 'vue-router';
import MapApp from './components/MapApp.vue';

// URL scheme (all under /maps/explore/):
//   /                          home: browse categories
//   /?category=dining          list of locations in a category
//   /?campus=ec                jump the camera to a campus (combinable with the above)
//   /rush-rhees-library        a location's details (same slugs as the previous app)
export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // One route so the map component is never torn down while navigating.
    { path: '/:slug?', name: 'map', component: MapApp },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

